export default {
  trackEvent (category, action, label) {
    if (typeof window.gaToAllTrackers === 'function') {
      window.gaToAllTrackers('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      })
    }
  },
  sendPageView (pageView) {
    if (typeof gaToAllTrackers === 'function') {
      window.gaToAllTrackers('send', 'pageview', pageView)
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/lib/google-analytics.js